var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlanUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.957,
    height: 41.957,
    viewBox: "0 0 41.957 41.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33556",
    "data-name": "Group 33556",
    transform: "translate(-1577 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13737",
    "data-name": "Rectangle 13737",
    width: 41.957,
    height: 41.957,
    rx: 8,
    transform: "translate(1577 98)",
    fill: "#ddfff7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "version",
    transform: "translate(1590 110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93661",
    "data-name": "Path 93661",
    d: "M9.391,15.913A1.391,1.391,0,0,1,8,14.522V3.391A1.391,1.391,0,0,1,9.391,2h7.652a1.391,1.391,0,0,1,1.391,1.391v11.13a1.391,1.391,0,0,1-1.391,1.391Zm-.348-1.391a.348.348,0,0,0,.348.348h7.652a.348.348,0,0,0,.348-.348V3.391a.348.348,0,0,0-.348-.348H9.391a.348.348,0,0,0-.348.348Z",
    transform: "translate(-2.435)",
    fill: "#1eac8f",
    stroke: "#1eac8f",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93662",
    "data-name": "Path 93662",
    d: "M5.51,4.038a.522.522,0,0,1-.233.7.713.713,0,0,0-.219.14.026.026,0,0,0-.006.011.269.269,0,0,0-.008.078v9.043a.269.269,0,0,0,.008.078.026.026,0,0,0,.006.011.714.714,0,0,0,.219.14.522.522,0,1,1-.467.933,1.653,1.653,0,0,1-.563-.416A1.144,1.144,0,0,1,4,14.011V4.967a1.145,1.145,0,0,1,.247-.746,1.653,1.653,0,0,1,.563-.416.522.522,0,0,1,.7.233Z",
    transform: "translate(-1.217 -0.533)",
    fill: "#1eac8f",
    stroke: "#1eac8f",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93663",
    "data-name": "Path 93663",
    d: "M1.5,5.51a.522.522,0,0,1-.19.713.869.869,0,0,0-.223.17c-.039.045-.039.066-.039.074v6.957c0,.007,0,.028.039.074a.87.87,0,0,0,.223.17.522.522,0,0,1-.522.9A1.378,1.378,0,0,1,0,13.424V6.467A1.378,1.378,0,0,1,.782,5.32.522.522,0,0,1,1.5,5.51Z",
    transform: "translate(0 -0.989)",
    fill: "#1eac8f",
    stroke: "#1eac8f",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanUpgrade);
export default __webpack_public_path__ + "static/media/IconPlanUpgrade.4aa7c5ac.svg";
export { ForwardRef as ReactComponent };